import { ArchiveState } from "@/store/Crud/functions/archived/State";

export class State extends ArchiveState {}
